<div class="page-layout carded fullwidth" >
  <mat-drawer-container class="overlay-container page-layout carded fullwidth" >

    <filtros [(filtro)]="filterForm" [hideFechaInicio]="true" [estados]="estados" [evaluador]="true" (loadData)="loadData()" (filterChange)="filterForm=$event"></filtros>
    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Operaciones</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <div class="content p-24">
              <button  mat-button (click)="viewStatistics()" mat-flat-button color="primary" class="add-row">
                <mat-icon  aria-hidden="false" aria-label="print" >bar_chart</mat-icon>
              </button>
                <button  mat-button (click)="print()" mat-flat-button color="primary" class="add-row">
                  <mat-icon  aria-hidden="false" aria-label="print" >print</mat-icon>
                </button>
                
                <table mat-table [dataSource]="dataSource" #mytable class="my-table mat-elevation-z8">

                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"

                                    >
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)"
                                    >
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef> Nombre. </th>
                    <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                  </ng-container>

                  <ng-container matColumnDef="estructuraJerarquica">
                    <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
                    <td mat-cell *matCellDef="let element"> {{element.estructuraJerarquica.nombre}} </td>
                  </ng-container>

                  <ng-container matColumnDef="marcoDeReferencia">
                    <th mat-header-cell *matHeaderCellDef> Marco de Referencia </th>
                    <td mat-cell *matCellDef="let element"> {{element.marcoDeReferencia.nombre}} </td>
                  </ng-container>

                  <ng-container matColumnDef="tablasDeEvaluacion">
                    <th mat-header-cell *matHeaderCellDef> Tabla de evaluación </th>
                    <td mat-cell *matCellDef="let element"> {{element.tablaDeDebidaDiligencia.nombre}} </td>
                  </ng-container>

                  <ng-container matColumnDef="responsable">
                    <th mat-header-cell *matHeaderCellDef> Responsable </th>
                    <td mat-cell *matCellDef="let element"> {{element.responsable.nombreCompleto}} </td>
                  </ng-container>

                  <ng-container matColumnDef="creador">
                    <th mat-header-cell *matHeaderCellDef> Creador </th>
                    <td mat-cell *matCellDef="let element"> {{element.creador.nombreCompleto}} </td>
                  </ng-container>

                  <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef> Estado </th>
                    <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
                  </ng-container>

                  <ng-container matColumnDef="fechaFin">
                    <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
                    <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Acción </th>


                    <td mat-cell *matCellDef="let element" class="action-link">
                      <a (click)="navegateTo('/debida-diligencia',element.id,element.uuid)"
                      *ngIf="element.tieneEditar || element.tieneEliminar">Ver</a>
                      <span *ngIf="element.tieneEditar"> | </span>
                      <a (click)="navegateTo('/debida-diligencia',element.id,element.uuid)" *ngIf="element.tieneEditar">Editar</a>
                      <span *ngIf="element.tieneEliminar"> | </span>
                      <a (click)="openDialog('Delete',element)" *ngIf="element.tieneEliminar">Eliminar</a>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <mat-paginator #paginator [length]="elementCount" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="basicSlice"
            (page)="OnePageChange($event)" showFirstLastButtons></mat-paginator>

            </div>

        </div>
        <!-- / CONTENT CARD -->
    </div>

  </mat-drawer-container>
</div>
